// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rD2nDzQZya74LLt18QzH {
  justify-content: stretch;
  margin: 24px 8px;
  padding: 30px;
  display: grid;
  color: var(--grey-gradient-middle-color-80);
  font-weight: 500;
  font-size: 16px;
  font-family: var(--font-stack-full-regular);
  grid-template-columns: 36px 20px repeat(3, calc((100% - 76px) / 3));
  grid-template-rows: repeat(3, auto) 20px 36px;
  grid-template-areas: "yTitle yLabel2 box2    box5    box8" "yTitle yLabel1 box1    box4    box7" "yTitle yLabel0 box0    box3    box6" ".      .       xLabel0 xLabel1 xLabel2" ".      .       xTitle  xTitle  xTitle";
}

.SwpvUgljO0brbeedKP6W, .FQwSl2_UW3A7xffMDkaR, .TJXwCrPz8fstZGBc91qx {
  background-color: var(--grey-color-200);
  display: inline-flex;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 50px;
  text-decoration: none;
  font-family: var(--font-stack-full-regular);
  font-weight: 400;
  line-height: 24px;
  font-size: 16px;
  margin: 0 0 6px 4px;
}

.W8KOHH1netNV2wAChlgE {
  padding: 24px;
}

.TJXwCrPz8fstZGBc91qx:hover {
  cursor: pointer;
}

.SwpvUgljO0brbeedKP6W {
  border: 1px solid var(--grey-color-60);
  margin: 0 0 4px 4px;
}

.SwpvUgljO0brbeedKP6W:hover {
  cursor: pointer;
}

.EHKKgkY1pRwfhE3JQMJ5 {
  background-color: var(--background-color);
  border-radius: 12px;
  border: 1px solid var(--grey-color-60);
  width: 24px;
  height: 24px;
  color: var(--grey-gradient-start-color-10);
  font-size: 12px;
  text-decoration: none;
  padding: 1px 3px 0px 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.WBBiBO1Z7Ss6Zr1a76EA {
  background-color: var(--green-color-400);
  border-radius: 12px;
  width: 24px;
  height: 24px;
  color: var(--grey-gradient-start-color-10);
  font-size: 12px;
  text-decoration: none;
  padding: 1px 3px 0px 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.p8CJa9Y9eTu4RR1UVNHb {
  color: var(--grey-gradient-end-color-10);
}

.Jj4V9Vn9tLFVfFxy_pLM {
  background-color: var(--grey-gradient-start-color-10);
  width: fit-content;
  line-height: 24px;
  font-size: 12px;
  font-weight: 400;
  padding: 2px 8px 0px;
  border-color: var(--grey-gradient-end-color-10);
  border-radius: 12px;
}

.gXgZaH3ZyODa73wi4u6p, .Lx7To80aKGniBXdhZTUj {
  text-transform: capitalize;
  text-decoration: none;
  position: relative;
  top: 2px;
  color: var(--grey-color-90);
}

.gXgZaH3ZyODa73wi4u6p {
  font-weight: 500;
  font-family: var(--font-stack-full-medium);
}

.c8J5g8TdBjRWvfQhs4jd {
  display: flex;
  gap: 10px;
  overflow: hidden;
}

.TzV0G2b9WMUsrameJM3g {
  padding-top: 2px;
  text-transform: none;
  text-decoration: none;
  line-height: 24px;
  font-size: 16px;
  font-weight: 400;
  color: var(--grey-color-90);
  cursor: pointer;
}

.XNA_MgDABsofhZB68QkT {
  background-color: var(--grey-color-10);
}

.ykCnCytOCbFd18zGXujy {
  height: 112px;
  overflow: hidden;
}

.ec3O2ZYBmsmQAHYJjpgf {
  padding: 20px 20px 0;
}

.dBaTgD4L1LKOyekybEK2 {
  display: inline-block;
  color: var(--grey-color-90);
  font-family: var(--font-stack-full-regular);
}

.h3c9zDbC2bJgDw6X86kt {
  justify-content: stretch;
  height: 230px;
  border: 1px solid var(--grey-color-20);
  padding: 15px;
  display: flex;
  gap: 8px;
  flex-direction: column;
}

.KFssAf3x0dNJ67uEbQEL {
  justify-content: stretch;
  text-align: center;
  font-weight: 400;
}

.GnLxFdyewWXZceU_ZpYU {
  align-items: center;
  font-weight: 400;
  display: flex;
  justify-content: center;
}

.IP3en44U9JJlkuK2ofOu {
  grid-area: box0;
}

.A4lu3dx5H7ACf1aX9UBT {
  grid-area: box1;
}

.pSqqt6fceB3Z12UGWeW7 {
  grid-area: box2;
}

.kSGgAIDtbrSL29DmKhig {
  grid-area: box3;
}

.KNyI8V7QHBKMysBNiyaI {
  grid-area: box4;
}

.U1Uiqoz0MxwkRSL2ZA6i {
  grid-area: box5;
}

.S1Ulp8V98FfJdWfY4yRg {
  grid-area: box6;
}

.j7j0jVVQxqJ0V_eW9qyV {
  grid-area: box7;
}

.saamwO4cXbOlZ1Tog7m1 {
  grid-area: box8;
}

.ea1kctOn9sjGcghQEMPv {
  grid-area: xLabel0;
}

.Ksycqht9ByFhGXu73zgm {
  grid-area: xLabel1;
}

.bNYoopeEHShmoQBzRCO3 {
  grid-area: xLabel2;
}

.PPtaGsdZnrEiljLtX7eQ {
  grid-area: yLabel0;
}

.dD7JzLAZhh4YAaNbdTjn {
  grid-area: yLabel1;
}

.ORkmx1TVd_q8KTMj1ndv {
  grid-area: yLabel2;
}

._4NQ0N5Ip8NV1HwG0mtE, .iZGDXej9KzJoVnOldOxV {
  border-radius: 24px;
}

.iZGDXej9KzJoVnOldOxV {
  grid-area: xTitle;
  padding: 6px;
  text-align: center;
}

._4NQ0N5Ip8NV1HwG0mtE {
  grid-area: yTitle;
  display: flex;
  align-items: center;
}

.pV2rWnhxohN2qjhUPDP7 {
  transform: rotate(-90deg);
  white-space: nowrap;
  margin-left: -75px;
  display: flex;
  gap: 5px;
  color: var(--grey-color-90);
  font-size: 16px;
  align-items: end;
}

.sNXy4iF73IxY7Y0nN4L7 {
  transform: rotate(-90deg);
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 16px;
  margin-right: 5px;
  color: #0b0c10;
}
.sNXy4iF73IxY7Y0nN4L7 .tuQnbM0RKyLsRl74jhD8 {
  transform: rotate(90deg);
}

.U9KEbCNVlLgLBUXNcVV2 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #0b0c10;
}

.WNwVNyd2FYnLdnqKAxNI {
  width: 20px;
}

.GYaNpceGSO8iubvgpCbu {
  margin-left: -60px;
}

.FjJ1AU6Cmfj06H0q8Znp {
  justify-content: space-between;
  padding: 32px 25px 0 32px;
  align-items: end;
  display: flex;
  width: 100%;
}

.U00YUQp8YzmCR_xIy_a_ {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.trBvs2O7Pk71XB1Jsuc9 {
  border-top: 1px solid var(--grey-gradient-end-color-10);
  width: calc(100% - 64px);
  margin: 0 32px 12px;
}

.mKtSbAbnuCSafRJ9UWNt {
  border-top: 1px solid black;
  width: calc(100% - 64px);
  margin: 0 32px;
  position: relative;
  top: 36px;
}

.hX34CbFQ1MYCMtpVpyqi {
  border: 1px dashed var(--grey-color-90);
}

.HtWFy9xCyu7glLiM6M82 {
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.25);
}

.noK1iJBSLNWOIF5UK7i2:hover {
  cursor: pointer;
}

.noK1iJBSLNWOIF5UK7i2 {
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.ZAMMzYMfM4XHEsO9bTbN {
  width: 24px;
  height: 24px;
  border-radius: 12px;
  background-color: var(--grey-color-60);
  color: var(--grey-gradient-start-color-10);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  line-height: 24px;
  font-weight: 400;
  font-family: var(--font-stack-full-regular);
  padding-top: 2px;
}

.CKyDwHU0JGvk7P82EN4c {
  min-width: 40px;
  min-height: 40px;
  border-radius: 24px;
  background-color: var(--grey-color-10);
  color: var(--grey-gradient-start-color-10);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  font-family: var(--font-stack-full-heavy);
}

.xj5gwZoQQV0J97WwaBS8 {
  text-wrap: nowrap;
  font-family: var(--font-stack-full-heavy);
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--grey-color-90);
}

.cZsuADa4gFKsO1wmF6PF {
  display: inline-flex;
  padding: 4px 8px;
}

.OYbn0UF7oEAgHb1UkM2O {
  padding: 2px 8px;
  font-family: var(--font-stack-full-book);
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--grey-color-60);
}

.th75V5KVassEJSyrje18 {
  margin-top: 14px;
  font-family: var(--font-stack-full-book);
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--grey-color-70);
}

.zr4keO7jCH_9QppHHKgf {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.hXHIA4aBMAxQx99Xw2Fr {
  font-family: var(--font-stack-full-regular);
  color: var(--grey-color-90);
}

.ZmSBxKZq0SAO20WjocUz {
  font-family: var(--font-stack-full-book);
  color: var(--grey-color-60);
}

.ywNVzHTCpw9gccqnzqfw {
  display: flex;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  width: 280px;
  border: 1px solid var(--grey-color-10);
  background-color: var(--grey-color-10);
  border-radius: 24px;
  padding: 5px 10px 5px 10px;
}

.TmvO8ZBjDiqFPtnRFOqc {
  background-color: var(--grey-gradient-start-color-10);
}

.LNtQiYMpZuzBSETfSYpb {
  box-shadow: none;
  display: inline-block;
  position: relative;
  right: -8px;
  top: 15px;
}

.NvWf0AePC50l67zzERbY {
  color: var(--grey-color-90);
  size: 20px;
}

.MgKS4QxuKswFuEtPHXF9 {
  width: 274px;
}

.KIiiQfjqE2IX6ONV7tPe {
  padding: 5px;
  cursor: pointer;
  border-radius: 15px;
  width: 240px;
}

.jnYqx2aXRAQs80TQFUgA {
  padding: 5px;
  cursor: pointer;
  border-radius: 15px;
  width: 240px;
  background-color: var(--grey-color-20);
}

.KIiiQfjqE2IX6ONV7tPe:hover {
  background-color: var(--grey-gradient-end-color-10);
}

.YMUcOIBowe3FFM42ty6I:focus-visible {
  box-shadow: 0px;
}

.DL5uMwsDSrCNyV_dgpXZ {
  position: absolute;
  z-index: 10;
  color: var(--grey-gradient-start-color-10);
  background-color: var(--grey-color-60);
  border-radius: 50px;
  left: 60px;
  top: 30px;
  font-size: 32px;
}

.d2fB9k58648PxZqIW7t5 {
  border-color: var(--grey-color-60);
}

.BCq5N7FpI1jNYSZ18e6R {
  position: absolute;
  top: 24px;
  right: 76px;
}

.jjj0o_kvii5UkhWkzwag {
  background-color: var(--grey-color-10);
}

.mOX4E55Hz3eWGiptBf9W {
  height: 42px;
}

.IEHfsUY7py1mQInW8FG6 {
  font-size: 20px;
  line-height: 28px;
  font-weight: 400;
}

.h9BYJV4YqqYRFIOEJpI6 {
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  margin-bottom: 4px;
  color: var(--grey-color-70);
}

.DfZyOlN3ppNHGKoqS6Zz {
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  color: var(--grey-color-60);
}

.o6KTurXSiyCyv8KpWDck {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: var(--grey-color-70);
}

.dwDjHP0eIn0D97WHKIgD {
  text-decoration: underline;
  cursor: pointer;
}

.YZxjN5Laer7LUsIlZvaa {
  color: var(--grey-color-90);
  margin-bottom: 5px;
  font-weight: 400;
  font-family: var(--font-stack-full-heavy);
  font-size: 16px;
  line-height: 24px;
}

.sWVucEXT_UWZmbDvuUL0 {
  word-wrap: break-word;
  font-weight: 400;
  font-family: var(--font-stack-full-book);
  color: var(--grey-color-90);
  font-size: 14px;
  line-height: 20px;
}

.Z0c4WlawKVMsklBPOgFU {
  position: absolute;
  bottom: 62px;
  font-family: var(--font-stack-full-book);
  font-weight: 400;
  line-height: 21px;
  font-size: 15px;
  color: var(--grey-color-90);
}

.D6DkNeefmUf9T8Y_Vyt0 {
  display: flex;
  font-family: var(--font-stack-full-book);
  position: relative;
  width: fit-content;
  padding: 6px 12px 6px 12px;
  cursor: pointer;
}

.mRM8RxhK8Uo3SBH7yWYO {
  color: var(--act-dark);
  border-color: var(--act-dark) !important;
}

.ZlSplrNIK14GVMqoPiEP {
  position: static !important;
}

.dGlV3n5orppgoHhyPRHz {
  border-radius: 8px;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  font-family: var(--font-stack-full-medium);
  color: var(--grey-color-90);
  cursor: pointer;
}

.TBIE9YX3hJRTUUmLxnQh {
  font-family: var(--font-stack-full-medium);
  color: var(--grey-color-90);
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}

.QbYRkeu7naEwQqoAOSpe {
  font-family: var(--font-stack-full-book);
  color: var(--grey-color-90);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
}

.ZELy3N5et26z8pvXsFuf {
  font-family: var(--font-stack-full-medium);
  color: var(--grey-color-90);
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}

.SHEEGJyIZxcBHk8PCyEI {
  margin-bottom: 36px;
}

.xld3SUHDOkqPrw6rbfLg {
  margin: 0 36px 60px;
}

.VBiSQQFSnyuXKKbY3OFK {
  margin-bottom: 12px;
}

.gfKXMSQUNi6JnDLuUfg5 {
  padding-bottom: 24px;
}

.bvox25T2tIKj8o4wgtKC {
  color: var(--red-color-20);
}

.FmopXp24Aag9EGIei7AV {
  font-family: var(--font-stack-full-medium);
  font-weight: 500;
  font-size: 16px;
  margin: 6px;
}

.sBo25kVyC6uvaYbJuMhU {
  border-top-left-radius: 24px;
}

.u8AZtbOfu2qLJuyqjdWb {
  border-top-width: 0px;
  border-bottom-width: 0px;
}

.wJj3gCc7vI6uUeg1grAX {
  border-top-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 0px;
}

.SPEDh4nQKVthupKakf_G {
  border-top-right-radius: 24px;
  border-left-width: 0px;
}

.BO7VaWG1ApZ9SFOhdJ5A {
  border-bottom-left-radius: 24px;
}

.KB_ltTQhm3t_kDJQ7HKH {
  border-bottom-right-radius: 24px;
  border-left-width: 0px;
}

.bnkx_AKU34w5SjvBR9YY {
  border-left-width: 0px;
}

.ZNGlpg2Qp52ZDUG62C5V {
  border-left-width: 0px;
  border-bottom-width: 0px;
  border-top-width: 0px;
}

.AeyYRdfkDiEJFPCDl1Wo {
  font-family: var(--font-stack-full-book);
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
}

.urFoIjW1OnbyS526OM9H {
  margin-bottom: 24px;
}

.CoOEGFMnaRVEf1zIlGHh {
  margin-bottom: 24px;
}

.Y2sGbIZDcPA2FNYavk4c {
  margin-bottom: 8px;
  font-family: var(--font-stack-full-heavy);
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
}

.uaSRxOJbllKrHlgpmwGy {
  font-weight: 800px;
  font-size: 20px;
  line-height: 28px;
  font-family: var(--font-stack-full-heavy);
}

.qKfa6pyHVDWxV9PYm0Ur {
  font-size: 16px;
  font-weight: 800;
  margin-top: 3px;
  line-height: 24px;
}

.GjaQkCBxPBmOSZ5hf0tE {
  border-radius: 50px;
  padding: 4px 8px 4px 8px;
  background-color: var(--grey-color-200);
}

.Ye4T8Uv01prn5P0elSD5 {
  margin-top: 4px;
  font-size: 14px;
  font-weight: 350;
  color: var(--grey-color-60);
}

.sjt_IL7X5esmMxZB0Fcu {
  display: flex;
  gap: 8px;
  background-color: var(--grey-color-200);
  border-radius: 50px;
  padding: 4px 8px 4px 8px;
}

.xJWowRbQF9zCr5BTIS2n {
  display: flex;
  gap: 24px;
  margin-bottom: 24px;
}

.ZAlguLuafoeZSaYEnqog {
  max-height: 600px;
  overflow-y: auto;
  scrollbar-color: black transparent;
  scrollbar-width: thin;
}

.iKwAFmuvZkjzFZTmlwYI {
  width: 65%;
}

.aVheayV7OGLqrBoCkbi4 {
  width: 25%;
  padding: 5px 0;
}

.B6nUQX9qr62aeSnV3Mxy {
  font-family: var(--font-stack-full-heavy);
  font-size: 16px;
  line-height: 24px;
}

.GcMIthcos_kHZPfFOs0Q {
  margin-top: 8px;
}

.SYIoZVoeyabH6YKy9Uyn {
  width: 10%;
  display: flex;
  justify-content: center;
  margin-top: 36px;
}

.yapMSiUsEkhk_Ze21c9b {
  display: flex;
  flex-direction: column;
}

.LlUlEWr4Wb24kfwOfuUr {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  margin: 24px 0;
}

.pS9_pOVDhY0I66cqFtDF {
  display: flex;
  gap: 8px;
  align-items: center;
}

.S1x60hZkvqvmR7s9FLpq {
  font-size: 20px;
  font-family: var(--font-stack-full-heavy);
  font-weight: 800;
  line-height: 28px;
}

.vTFTo1t7XsrgBsCjlXKR {
  display: flex;
  justify-content: space-around;
  font-family: var(--font-stack-full-regular);
  font-size: 12px;
  color: var(--background-color);
  padding: 1px 0 0 0;
  border-radius: 50%;
  background-color: var(--grey-color-60);
  width: 24px;
  height: 24px;
}

.vlBQCr9ZO0wtRdnayG7c {
  width: 22%;
  padding: 1px;
}

.GUyMx1EFYHV4b8cd39gL {
  pointer-events: none;
  opacity: 0.5;
  background-color: #f0f0f0;
}

.RqwQmlLX97MMhAUYRDzw {
  height: 40px;
  min-width: 150px;
}

.TzrPOBd8FA1rrhMvoknZ {
  font-family: var(--font-stack-full-book);
  font-size: 18px;
  line-height: 20px;
  color: var(--grey-color-70);
}

.SsApMBiZlomShJ02wffu {
  display: flex;
  align-items: center;
  gap: 8px;
}

.DVy8lNFQDKk5f0Zkvbdb {
  font-size: 18px;
  font-family: var(--font-stack-full-book);
  line-height: 24px;
  font-weight: 400;
  color: var(--grey-color-70);
}

.aeV96r0etamyoTKViNt1 {
  font-size: 16px;
  color: var(--grey-color-70);
  font-family: var(--font-stack-full-book);
  font-weight: 400;
}

.pXtEApzvap7vogxOmI4N {
  font-size: 16px;
  font-family: var(--font-stack-full-heavy);
  color: var(--grey-color-60);
}`, "",{"version":3,"sources":["webpack://./src/components/NineBox/NineBox.module.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,2CAAA;EACA,gBAAA;EACA,eAAA;EACA,2CAAA;EACA,mEAAA;EACA,6CAAA;EACA,uNACE;AAAJ;;AAOA;EACE,uCAAA;EACA,oBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,2CAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAJF;;AAOA;EACE,aAAA;AAJF;;AAOA;EACE,eAAA;AAJF;;AAeA;EAEE,sCAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,eAAA;AAbF;;AAgBA;EACE,yCAAA;EACA,mBAAA;EACA,sCAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,eAAA;EACA,qBAAA;EACA,wBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,wCAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,eAAA;EACA,qBAAA;EACA,wBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,wCAAA;AAbF;;AAgBA;EACE,qDAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,+CAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,0BAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;AAbF;;AAkBA;EAEE,gBAAA;EACA,0CAAA;AAhBF;;AAkBA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,eAAA;AAfF;;AAkBA;EACE,sCAAA;AAfF;;AAkBA;EACE,aAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,oBAAA;AAfF;;AAkBA;EACE,qBAAA;EACA,2BAAA;EACA,2CAAA;AAfF;;AAkBA;EACE,wBAAA;EACA,aAAA;EACA,sCAAA;EACA,aAAA;EACA,aAAA;EACA,QAAA;EACA,sBAAA;AAfF;;AAkBA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;AAfF;;AAmBE;EACE,eAAA;AAhBJ;;AAeE;EACE,eAAA;AAZJ;;AAWE;EACE,eAAA;AARJ;;AAOE;EACE,eAAA;AAJJ;;AAGE;EACE,eAAA;AAAJ;;AADE;EACE,eAAA;AAIJ;;AALE;EACE,eAAA;AAQJ;;AATE;EACE,eAAA;AAYJ;;AAbE;EACE,eAAA;AAgBJ;;AAXE;EACE,kBAAA;AAcJ;;AAfE;EACE,kBAAA;AAkBJ;;AAnBE;EACE,kBAAA;AAsBJ;;AAjBE;EACE,kBAAA;AAoBJ;;AArBE;EACE,kBAAA;AAwBJ;;AAzBE;EACE,kBAAA;AA4BJ;;AAxBA;EACE,mBAAA;AA2BF;;AAxBA;EAEE,iBAAA;EACA,YAAA;EACA,kBAAA;AA0BF;;AAvBA;EAEE,iBAAA;EACA,aAAA;EACA,mBAAA;AAyBF;;AAtBA;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;AAyBF;;AAtBA;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAyBF;AAvBE;EACE,wBAAA;AAyBJ;;AArBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;AAwBF;;AArBA;EACE,WAAA;AAwBF;;AArBA;EACE,kBAAA;AAwBF;;AArBA;EACE,8BAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;AAwBF;;AArBA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AAwBF;;AArBA;EACE,uDAAA;EACA,wBAAA;EACA,mBAAA;AAwBF;;AArBA;EACE,2BAAA;EACA,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;AAwBF;;AArBA;EACE,uCAAA;AAwBF;;AArBA;EACE,yCAAA;AAwBF;;AArBA;EACE,eAAA;AAwBF;;AArBA;EACE,mBAAA;EACA,QAAA;EACA,eAAA;AAwBF;;AArBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sCAAA;EACA,0CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,2CAAA;EACA,gBAAA;AAwBF;;AArBA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,sCAAA;EACA,0CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,yCAAA;AAwBF;;AArBA;EACE,iBAAA;EACA,yCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AAwBF;;AArBA;EACE,oBAAA;EACA,gBAAA;AAwBF;;AArBA;EACE,gBAAA;EACA,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AAwBF;;AArBA;EACE,gBAAA;EACA,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AAwBF;;AArBA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAwBF;;AArBA;EACE,2CAAA;EACA,2BAAA;AAwBF;;AArBA;EACE,wCAAA;EACA,2BAAA;AAwBF;;AArBA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,sCAAA;EACA,sCAAA;EACA,mBAAA;EACA,0BAAA;AAwBF;;AArBA;EACE,qDAAA;AAwBF;;AArBA;EACE,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AAwBF;;AArBA;EACE,2BAAA;EACA,UAAA;AAwBF;;AArBA;EACE,YAAA;AAwBF;;AAdA;EANE,YAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AAwBF;;AAjBA;EAVE,YAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EASA,sCAAA;AAuBF;;AApBA;EACE,mDAAA;AAuBF;;AApBA;EACE,eAAA;AAuBF;;AApBA;EACE,kBAAA;EACA,WAAA;EACA,0CAAA;EACA,sCAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AAuBF;;AApBA;EACE,kCAAA;AAuBF;;AApBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AAuBF;;AApBA;EACE,sCAAA;AAuBF;;AApBA;EACE,YAAA;AAuBF;;AApBA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AAuBF;;AAhBA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;AAmBF;;AAhBA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;AAmBF;;AAhBA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;AAmBF;;AAhBA;EACE,0BAAA;EACA,eAAA;AAmBF;;AAhBA;EACE,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;EACA,eAAA;EACA,iBAAA;AAmBF;;AAhBA;EACE,qBAAA;EACA,gBAAA;EACA,wCAAA;EACA,2BAAA;EACA,eAAA;EACA,iBAAA;AAmBF;;AAhBA;EACE,kBAAA;EACA,YAAA;EACA,wCAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,2BAAA;AAmBF;;AAhBA;EACE,aAAA;EACA,wCAAA;EACA,kBAAA;EACA,kBAAA;EACA,0BAAA;EACA,eAAA;AAmBF;;AAhBA;EACE,sBAAA;EACA,wCAAA;AAmBF;;AAhBA;EACE,2BAAA;AAmBF;;AAhBA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,2BAAA;EACA,eAAA;AAmBF;;AAhBA;EACE,0CAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAmBF;;AAhBA;EACE,wCAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAmBF;;AAhBA;EACE,0CAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAmBF;;AAhBA;EACE,mBAAA;AAmBF;;AAhBA;EACE,mBAAA;AAmBF;;AAhBA;EACE,mBAAA;AAmBF;;AAhBA;EACE,oBAAA;AAmBF;;AAjBA;EACE,0BAAA;AAoBF;;AAlBA;EACE,0CAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AAqBF;;AAnBA;EACE,4BAAA;AAsBF;;AApBA;EACE,qBAAA;EACA,wBAAA;AAuBF;;AArBA;EACE,qBAAA;EACA,wBAAA;EACA,sBAAA;AAwBF;;AAtBA;EACE,6BAAA;EACA,sBAAA;AAyBF;;AAvBA;EACE,+BAAA;AA0BF;;AAxBA;EACE,gCAAA;EACA,sBAAA;AA2BF;;AAzBA;EACE,sBAAA;AA4BF;;AA1BA;EACE,sBAAA;EACA,wBAAA;EACA,qBAAA;AA6BF;;AA3BA;EACE,wCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AA8BF;;AA5BA;EACE,mBAAA;AA+BF;;AA7BA;EACE,mBAAA;AAgCF;;AA9BA;EACE,kBAAA;EACA,yCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAiCF;;AA/BA;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,yCAAA;AAkCF;;AAhCA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAmCF;;AAjCA;EACE,mBAAA;EACA,wBAAA;EACA,uCAAA;AAoCF;;AAlCA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AAqCF;;AAlCA;EACE,aAAA;EACA,QAAA;EACA,uCAAA;EACA,mBAAA;EACA,wBAAA;AAqCF;;AAlCA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAqCF;;AAlCA;EACE,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,qBAAA;AAqCF;;AAlCA;EACE,UAAA;AAqCF;;AAlCA;EACE,UAAA;EACA,cAAA;AAqCF;;AAlCA;EACE,yCAAA;EACA,eAAA;EACA,iBAAA;AAqCF;;AAlCA;EACE,eAAA;AAqCF;;AAlCA;EACE,UAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AAqCF;;AAlCA;EACE,aAAA;EAEA,sBAAA;AAoCF;;AAjCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AAoCF;;AAjCA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAoCF;;AAjCA;EACE,eAAA;EACA,yCAAA;EACA,gBAAA;EACA,iBAAA;AAoCF;;AAjCA;EACE,aAAA;EACA,6BAAA;EACA,2CAAA;EACA,eAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,sCAAA;EACA,WAAA;EACA,YAAA;AAoCF;;AAjCA;EACE,UAAA;EACA,YAAA;AAoCF;;AAjCA;EACE,oBAAA;EACA,YAAA;EACA,yBAAA;AAoCF;;AAlCA;EACE,YAAA;EACA,gBAAA;AAqCF;;AAnCA;EACE,wCAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AAsCF;;AApCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAuCF;;AApCA;EACE,eAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;AAuCF;;AApCA;EACE,eAAA;EACA,2BAAA;EACA,wCAAA;EACA,gBAAA;AAuCF;;AApCA;EACE,eAAA;EACA,yCAAA;EACA,2BAAA;AAuCF","sourcesContent":[".wholeGrid {\n  justify-content: stretch;\n  margin: 24px 8px;\n  padding: 30px;\n  display: grid;\n  color: var(--grey-gradient-middle-color-80);\n  font-weight: 500;\n  font-size: 16px;\n  font-family: var(--font-stack-full-regular);\n  grid-template-columns: 36px 20px repeat(3, calc((100% - 76px) / 3));\n  grid-template-rows: repeat(3, auto) 20px 36px;\n  grid-template-areas:\n    \"yTitle yLabel2 box2    box5    box8\"\n    \"yTitle yLabel1 box1    box4    box7\"\n    \"yTitle yLabel0 box0    box3    box6\"\n    \".      .       xLabel0 xLabel1 xLabel2\"\n    \".      .       xTitle  xTitle  xTitle\";\n}\n\n%leaderTileStyles {\n  background-color: var(--grey-color-200);\n  display: inline-flex;\n  gap: 8px;\n  padding: 4px 8px;\n  border-radius: 50px;\n  text-decoration: none;\n  font-family: var(--font-stack-full-regular);\n  font-weight: 400;\n  line-height: 24px;\n  font-size: 16px;\n  margin: 0 0 6px 4px;\n}\n\n.filters {\n  padding: 24px;\n}\n\n.leaderTile:hover {\n  cursor: pointer;\n}\n\n.leaderTile {\n  @extend %leaderTileStyles;\n}\n\n.leaderTileReadOnly {\n  @extend %leaderTileStyles;\n}\n\n.leaderTileMoved {\n  @extend %leaderTileStyles;\n  border: 1px solid var(--grey-color-60);\n  margin: 0 0 4px 4px;\n}\n\n.leaderTileMoved:hover {\n  cursor: pointer;\n}\n\n.leaderInitials {\n  background-color: var(--background-color);\n  border-radius: 12px;\n  border: 1px solid var(--grey-color-60);\n  width: 24px;\n  height: 24px;\n  color: var(--grey-gradient-start-color-10);\n  font-size: 12px;\n  text-decoration: none;\n  padding: 1px 3px 0px 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.leaderSaved {\n  background-color: var(--green-color-400);\n  border-radius: 12px;\n  width: 24px;\n  height: 24px;\n  color: var(--grey-gradient-start-color-10);\n  font-size: 12px;\n  text-decoration: none;\n  padding: 1px 3px 0px 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.leaderDivider {\n  color: var(--grey-gradient-end-color-10);\n}\n\n.leaderSpilloverCount {\n  background-color: var(--grey-gradient-start-color-10);\n  width: fit-content;\n  line-height: 24px;\n  font-size: 12px;\n  font-weight: 400;\n  padding: 2px 8px 0px;\n  border-color: var(--grey-gradient-end-color-10);\n  border-radius: 12px;\n}\n\n%leaderNameStyle {\n  text-transform: capitalize;\n  text-decoration: none;\n  position: relative;\n  top: 2px;\n  color: var(--grey-color-90);\n}\n.leaderName {\n  @extend %leaderNameStyle;\n}\n.leaderNameBold {\n  @extend %leaderNameStyle;\n  font-weight: 500;\n  font-family: var(--font-stack-full-medium);\n}\n.leaderOverflowDescription {\n  display: flex;\n  gap: 10px;\n  overflow: hidden;\n}\n\n.leaderClickSeeOverflow {\n  padding-top: 2px;\n  text-transform: none;\n  text-decoration: none;\n  line-height: 24px;\n  font-size: 16px;\n  font-weight: 400;\n  color: var(--grey-color-90);\n  cursor: pointer;\n}\n\n.leaderOverflow {\n  background-color: var(--grey-color-10);\n}\n\n.leaderBox {\n  height: 112px;\n  overflow: hidden;\n}\n\n.doneContainer {\n  padding: 20px 20px 0;\n}\n\n.boxName {\n  display: inline-block;\n  color: var(--grey-color-90);\n  font-family: var(--font-stack-full-regular);\n}\n\n.box {\n  justify-content: stretch;\n  height: 230px;\n  border: 1px solid var(--grey-color-20);\n  padding: 15px;\n  display: flex;\n  gap: 8px;\n  flex-direction: column;\n}\n\n.xLabel {\n  justify-content: stretch;\n  text-align: center;\n  font-weight: 400;\n}\n\n.yLabel {\n  align-items: center;\n  font-weight: 400;\n  display: flex;\n  justify-content: center;\n}\n\n@for $i from 0 through 8 {\n  .box#{$i} {\n    grid-area: box#{$i};\n  }\n}\n\n@for $i from 0 through 2 {\n  .xLabel#{$i} {\n    grid-area: xLabel#{$i};\n  }\n}\n\n@for $i from 0 through 2 {\n  .yLabel#{$i} {\n    grid-area: yLabel#{$i};\n  }\n}\n\n%axisTitle {\n  border-radius: 24px;\n}\n\n.xTitle {\n  @extend %axisTitle;\n  grid-area: xTitle;\n  padding: 6px;\n  text-align: center;\n}\n\n.yTitle {\n  @extend %axisTitle;\n  grid-area: yTitle;\n  display: flex;\n  align-items: center;\n}\n\n.yTitleText {\n  transform: rotate(-90deg);\n  white-space: nowrap;\n  margin-left: -75px;\n  display: flex;\n  gap: 5px;\n  color: var(--grey-color-90);\n  font-size: 16px;\n  align-items: end;\n}\n\n.yLabelText {\n  transform: rotate(-90deg);\n  white-space: nowrap;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  font-size: 16px;\n  margin-right: 5px;\n  color: #0b0c10;\n\n  .labelRevertIcon {\n    transform: rotate(90deg);\n  }\n}\n\n.xLabelText {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  color: #0b0c10;\n}\n\n.verticalLabelTooltip {\n  width: 20px;\n}\n\n.verticalTitleTooltip {\n  margin-left: -60px;\n}\n\n.statusRow {\n  justify-content: space-between;\n  padding: 32px 25px 0 32px;\n  align-items: end;\n  display: flex;\n  width: 100%;\n}\n\n.statusRowButtons {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n}\n\n.horizontalRule {\n  border-top: 1px solid var(--grey-gradient-end-color-10);\n  width: calc(100% - 64px);\n  margin: 0 32px 12px;\n}\n\n.leaderListHorizontalRule {\n  border-top: 1px solid black;\n  width: calc(100% - 64px);\n  margin: 0 32px;\n  position: relative;\n  top: 36px;\n}\n\n.dragOverBox {\n  border: 1px dashed var(--grey-color-90);\n}\n\n.draggingPill {\n  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.25);\n}\n\n.nameRoleWrapper:hover {\n  cursor: pointer;\n}\n\n.nameRoleWrapper {\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.nameBubbleSmall {\n  width: 24px;\n  height: 24px;\n  border-radius: 12px;\n  background-color: var(--grey-color-60);\n  color: var(--grey-gradient-start-color-10);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n  line-height: 24px;\n  font-weight: 400;\n  font-family: var(--font-stack-full-regular);\n  padding-top: 2px;\n}\n\n.nameBubble {\n  min-width: 40px;\n  min-height: 40px;\n  border-radius: 24px;\n  background-color: var(--grey-color-10);\n  color: var(--grey-gradient-start-color-10);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 400;\n  font-family: var(--font-stack-full-heavy);\n}\n\n.nameAndRoleContainer {\n  text-wrap: nowrap;\n  font-family: var(--font-stack-full-heavy);\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--grey-color-90);\n}\n\n.nameAndRole {\n  display: inline-flex;\n  padding: 4px 8px;\n}\n\n.roles {\n  padding: 2px 8px;\n  font-family: var(--font-stack-full-book);\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: var(--grey-color-60);\n}\n\n.timeAndRole {\n  margin-top: 14px;\n  font-family: var(--font-stack-full-book);\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: var(--grey-color-70);\n}\n\n.columnTitles {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.tableColumnTitle {\n  font-family: var(--font-stack-full-regular);\n  color: var(--grey-color-90);\n}\n\n.columnSubTitle {\n  font-family: var(--font-stack-full-book);\n  color: var(--grey-color-60);\n}\n\n.tableAssignedCell {\n  display: flex;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  width: 280px;\n  border: 1px solid var(--grey-color-10);\n  background-color: var(--grey-color-10);\n  border-radius: 24px;\n  padding: 5px 10px 5px 10px;\n}\n\n.tableAssignedCellContent {\n  background-color: var(--grey-gradient-start-color-10);\n}\n\n.tableAssignedCellCarrot {\n  box-shadow: none;\n  display: inline-block;\n  position: relative;\n  right: -8px;\n  top: 15px;\n}\n\n.tableAssignedCellCarrotIcon {\n  color: var(--grey-color-90);\n  size: 20px;\n}\n\n.tableAssignedCellDropdown {\n  width: 274px;\n}\n\n@mixin dropdownItem {\n  padding: 5px;\n  cursor: pointer;\n  border-radius: 15px;\n  width: 240px;\n}\n\n.tableAssignedCellDropdownItem {\n  @include dropdownItem;\n}\n\n.tableAssignedCellDropdownItemSelected {\n  @include dropdownItem;\n  background-color: var(--grey-color-20);\n}\n\n.tableAssignedCellDropdownItem:hover {\n  background-color: var(--grey-gradient-end-color-10);\n}\n\n.tableAssignedCellDropdownReference:focus-visible {\n  box-shadow: 0px;\n}\n\n.avatar {\n  position: absolute;\n  z-index: 10;\n  color: var(--grey-gradient-start-color-10);\n  background-color: var(--grey-color-60);\n  border-radius: 50px;\n  left: 60px;\n  top: 30px;\n  font-size: 32px;\n}\n\n.leaderPanelButton {\n  border-color: var(--grey-color-60);\n}\n\n.leaderViewProfile {\n  position: absolute;\n  top: 24px;\n  right: 76px;\n}\n\n.leaderBottomCard {\n  background-color: var(--grey-color-10);\n}\n\n.leaderAvatarSpacer {\n  height: 42px;\n}\n\n%loudTextBase {\n  font-size: 20px;\n  line-height: 28px;\n  font-weight: 400;\n}\n\n.loudText {\n  @extend %loudTextBase;\n}\n\n.leaderPanelLoud {\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 500;\n  margin-bottom: 4px;\n  color: var(--grey-color-70);\n}\n\n.leaderPanelTitle {\n  font-size: 14px;\n  line-height: 24px;\n  font-weight: 400;\n  color: var(--grey-color-60);\n}\n\n.leaderPanelInfo {\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 400;\n  color: var(--grey-color-70);\n}\n\n.tableReasonForMovementCellButton {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.tableReasonForMovementDetailsTitle {\n  color: var(--grey-color-90);\n  margin-bottom: 5px;\n  font-weight: 400;\n  font-family: var(--font-stack-full-heavy);\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.tableReasonForMovementDetailsBody {\n  word-wrap: break-word;\n  font-weight: 400;\n  font-family: var(--font-stack-full-book);\n  color: var(--grey-color-90);\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.showingInfo {\n  position: absolute;\n  bottom: 62px;\n  font-family: var(--font-stack-full-book);\n  font-weight: 400;\n  line-height: 21px;\n  font-size: 15px;\n  color: var(--grey-color-90);\n}\n\n.menuItem {\n  display: flex;\n  font-family: var(--font-stack-full-book);\n  position: relative;\n  width: fit-content;\n  padding: 6px 12px 6px 12px;\n  cursor: pointer;\n}\n\n.formError {\n  color: var(--act-dark);\n  border-color: var(--act-dark) !important;\n}\n\n.panelHeader {\n  position: static !important;\n}\n\n.selectableVersionHeader {\n  border-radius: 8px;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 28px;\n  font-family: var(--font-stack-full-medium);\n  color: var(--grey-color-90);\n  cursor: pointer;\n}\n\n.selectableVersionUserName {\n  font-family: var(--font-stack-full-medium);\n  color: var(--grey-color-90);\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  text-align: left;\n}\n\n.selectableVersionChange {\n  font-family: var(--font-stack-full-book);\n  color: var(--grey-color-90);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  text-align: left;\n}\n\n.selectableVersionDateTime {\n  font-family: var(--font-stack-full-medium);\n  color: var(--grey-color-90);\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  text-align: left;\n}\n\n.gridHorizontalRuleShell {\n  margin-bottom: 36px;\n}\n\n.allBannerStack {\n  margin: 0 36px 60px;\n}\n\n.disappearingBannerStack {\n  margin-bottom: 12px;\n}\n\n.boxListContainer {\n  padding-bottom: 24px;\n}\n.flagIcon {\n  color: var(--red-color-20);\n}\n.nineboxLeaderCount {\n  font-family: var(--font-stack-full-medium);\n  font-weight: 500;\n  font-size: 16px;\n  margin: 6px;\n}\n.borderTopLeftRadius {\n  border-top-left-radius: 24px;\n}\n.noBorderTopBottom {\n  border-top-width: 0px;\n  border-bottom-width: 0px;\n}\n.noBorderTopBottomLeft {\n  border-top-width: 0px;\n  border-bottom-width: 0px;\n  border-left-width: 0px;\n}\n.borderTopRightRadius {\n  border-top-right-radius: 24px;\n  border-left-width: 0px;\n}\n.borderBottomLeftRadius {\n  border-bottom-left-radius: 24px;\n}\n.borderBottomRightRadius {\n  border-bottom-right-radius: 24px;\n  border-left-width: 0px;\n}\n.noLeftBorder {\n  border-left-width: 0px;\n}\n.noBorderLeftBottom {\n  border-left-width: 0px;\n  border-bottom-width: 0px;\n  border-top-width: 0px;\n}\n.axisTooltipModalContainer {\n  font-family: var(--font-stack-full-book);\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 400;\n}\n.axisHeaderTitle {\n  margin-bottom: 24px;\n}\n.scaleTitleContainer {\n  margin-bottom: 24px;\n}\n.scaleTitle {\n  margin-bottom: 8px;\n  font-family: var(--font-stack-full-heavy);\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 400;\n}\n.cardPanelLoud {\n  font-weight: 800px;\n  font-size: 20px;\n  line-height: 28px;\n  font-family: var(--font-stack-full-heavy);\n}\n.managerName {\n  font-size: 16px;\n  font-weight: 800;\n  margin-top: 3px;\n  line-height: 24px;\n}\n.leaderDetailsPanel {\n  border-radius: 50px;\n  padding: 4px 8px 4px 8px;\n  background-color: var(--grey-color-200);\n}\n.managerRole {\n  margin-top: 4px;\n  font-size: 14px;\n  font-weight: 350;\n  color: var(--grey-color-60);\n}\n\n.leaderNamePanel {\n  display: flex;\n  gap: 8px;\n  background-color: var(--grey-color-200);\n  border-radius: 50px;\n  padding: 4px 8px 4px 8px;\n}\n\n.sharePermissionModalBodyContainer {\n  display: flex;\n  gap: 24px;\n  margin-bottom: 24px;\n}\n\n.sharePermissionModalWindowContainer {\n  max-height: 600px;\n  overflow-y: auto;\n  scrollbar-color: black transparent;\n  scrollbar-width: thin;\n}\n\n.autoCompleteInputBox {\n  width: 65%;\n}\n\n.permissionTypeContainer {\n  width: 25%;\n  padding: 5px 0;\n}\n\n.permissionTypeLabel {\n  font-family: var(--font-stack-full-heavy);\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.viewEditDropdown {\n  margin-top: 8px;\n}\n\n.addPermissionsButtonContainer {\n  width: 10%;\n  display: flex;\n  justify-content: center;\n  margin-top: 36px;\n}\n\n.shareChangebles {\n  display: flex;\n\n  flex-direction: column;\n}\n\n.leaderNameTitleAndButtonContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px;\n  margin: 24px 0;\n}\n\n.leaderNameAndTitleContainer {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.shareAccessPermissionHeader {\n  font-size: 20px;\n  font-family: var(--font-stack-full-heavy);\n  font-weight: 800;\n  line-height: 28px;\n}\n\n.leaderNameBubble {\n  display: flex;\n  justify-content: space-around;\n  font-family: var(--font-stack-full-regular);\n  font-size: 12px;\n  color: var(--background-color);\n  padding: 1px 0 0 0;\n  border-radius: 50%;\n  background-color: var(--grey-color-60);\n  width: 24px;\n  height: 24px;\n}\n\n.downViewEditDropdownContainer {\n  width: 22%;\n  padding: 1px;\n}\n\n.disableIcons {\n  pointer-events: none;\n  opacity: 0.5;\n  background-color: #f0f0f0;\n}\n.tooltipSize {\n  height: 40px;\n  min-width: 150px;\n}\n.requiresEditAccessModal {\n  font-family: var(--font-stack-full-book);\n  font-size: 18px;\n  line-height: 20px;\n  color: var(--grey-color-70);\n}\n.leaderPanelRecommendedBox {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.bannerMessage {\n  font-size: 18px;\n  font-family: var(--font-stack-full-book);\n  line-height: 24px;\n  font-weight: 400;\n  color: var(--grey-color-70);\n}\n\n.notificationMessages {\n  font-size: 16px;\n  color: var(--grey-color-70);\n  font-family: var(--font-stack-full-book);\n  font-weight: 400;\n}\n\n.tableHeaders {\n  font-size: 16px;\n  font-family: var(--font-stack-full-heavy);\n  color: var(--grey-color-60);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wholeGrid": `rD2nDzQZya74LLt18QzH`,
	"leaderTileMoved": `SwpvUgljO0brbeedKP6W`,
	"leaderTileReadOnly": `FQwSl2_UW3A7xffMDkaR`,
	"leaderTile": `TJXwCrPz8fstZGBc91qx`,
	"filters": `W8KOHH1netNV2wAChlgE`,
	"leaderInitials": `EHKKgkY1pRwfhE3JQMJ5`,
	"leaderSaved": `WBBiBO1Z7Ss6Zr1a76EA`,
	"leaderDivider": `p8CJa9Y9eTu4RR1UVNHb`,
	"leaderSpilloverCount": `Jj4V9Vn9tLFVfFxy_pLM`,
	"leaderNameBold": `gXgZaH3ZyODa73wi4u6p`,
	"leaderName": `Lx7To80aKGniBXdhZTUj`,
	"leaderOverflowDescription": `c8J5g8TdBjRWvfQhs4jd`,
	"leaderClickSeeOverflow": `TzV0G2b9WMUsrameJM3g`,
	"leaderOverflow": `XNA_MgDABsofhZB68QkT`,
	"leaderBox": `ykCnCytOCbFd18zGXujy`,
	"doneContainer": `ec3O2ZYBmsmQAHYJjpgf`,
	"boxName": `dBaTgD4L1LKOyekybEK2`,
	"box": `h3c9zDbC2bJgDw6X86kt`,
	"xLabel": `KFssAf3x0dNJ67uEbQEL`,
	"yLabel": `GnLxFdyewWXZceU_ZpYU`,
	"box0": `IP3en44U9JJlkuK2ofOu`,
	"box1": `A4lu3dx5H7ACf1aX9UBT`,
	"box2": `pSqqt6fceB3Z12UGWeW7`,
	"box3": `kSGgAIDtbrSL29DmKhig`,
	"box4": `KNyI8V7QHBKMysBNiyaI`,
	"box5": `U1Uiqoz0MxwkRSL2ZA6i`,
	"box6": `S1Ulp8V98FfJdWfY4yRg`,
	"box7": `j7j0jVVQxqJ0V_eW9qyV`,
	"box8": `saamwO4cXbOlZ1Tog7m1`,
	"xLabel0": `ea1kctOn9sjGcghQEMPv`,
	"xLabel1": `Ksycqht9ByFhGXu73zgm`,
	"xLabel2": `bNYoopeEHShmoQBzRCO3`,
	"yLabel0": `PPtaGsdZnrEiljLtX7eQ`,
	"yLabel1": `dD7JzLAZhh4YAaNbdTjn`,
	"yLabel2": `ORkmx1TVd_q8KTMj1ndv`,
	"yTitle": `_4NQ0N5Ip8NV1HwG0mtE`,
	"xTitle": `iZGDXej9KzJoVnOldOxV`,
	"yTitleText": `pV2rWnhxohN2qjhUPDP7`,
	"yLabelText": `sNXy4iF73IxY7Y0nN4L7`,
	"labelRevertIcon": `tuQnbM0RKyLsRl74jhD8`,
	"xLabelText": `U9KEbCNVlLgLBUXNcVV2`,
	"verticalLabelTooltip": `WNwVNyd2FYnLdnqKAxNI`,
	"verticalTitleTooltip": `GYaNpceGSO8iubvgpCbu`,
	"statusRow": `FjJ1AU6Cmfj06H0q8Znp`,
	"statusRowButtons": `U00YUQp8YzmCR_xIy_a_`,
	"horizontalRule": `trBvs2O7Pk71XB1Jsuc9`,
	"leaderListHorizontalRule": `mKtSbAbnuCSafRJ9UWNt`,
	"dragOverBox": `hX34CbFQ1MYCMtpVpyqi`,
	"draggingPill": `HtWFy9xCyu7glLiM6M82`,
	"nameRoleWrapper": `noK1iJBSLNWOIF5UK7i2`,
	"nameBubbleSmall": `ZAMMzYMfM4XHEsO9bTbN`,
	"nameBubble": `CKyDwHU0JGvk7P82EN4c`,
	"nameAndRoleContainer": `xj5gwZoQQV0J97WwaBS8`,
	"nameAndRole": `cZsuADa4gFKsO1wmF6PF`,
	"roles": `OYbn0UF7oEAgHb1UkM2O`,
	"timeAndRole": `th75V5KVassEJSyrje18`,
	"columnTitles": `zr4keO7jCH_9QppHHKgf`,
	"tableColumnTitle": `hXHIA4aBMAxQx99Xw2Fr`,
	"columnSubTitle": `ZmSBxKZq0SAO20WjocUz`,
	"tableAssignedCell": `ywNVzHTCpw9gccqnzqfw`,
	"tableAssignedCellContent": `TmvO8ZBjDiqFPtnRFOqc`,
	"tableAssignedCellCarrot": `LNtQiYMpZuzBSETfSYpb`,
	"tableAssignedCellCarrotIcon": `NvWf0AePC50l67zzERbY`,
	"tableAssignedCellDropdown": `MgKS4QxuKswFuEtPHXF9`,
	"tableAssignedCellDropdownItem": `KIiiQfjqE2IX6ONV7tPe`,
	"tableAssignedCellDropdownItemSelected": `jnYqx2aXRAQs80TQFUgA`,
	"tableAssignedCellDropdownReference": `YMUcOIBowe3FFM42ty6I`,
	"avatar": `DL5uMwsDSrCNyV_dgpXZ`,
	"leaderPanelButton": `d2fB9k58648PxZqIW7t5`,
	"leaderViewProfile": `BCq5N7FpI1jNYSZ18e6R`,
	"leaderBottomCard": `jjj0o_kvii5UkhWkzwag`,
	"leaderAvatarSpacer": `mOX4E55Hz3eWGiptBf9W`,
	"loudText": `IEHfsUY7py1mQInW8FG6`,
	"leaderPanelLoud": `h9BYJV4YqqYRFIOEJpI6`,
	"leaderPanelTitle": `DfZyOlN3ppNHGKoqS6Zz`,
	"leaderPanelInfo": `o6KTurXSiyCyv8KpWDck`,
	"tableReasonForMovementCellButton": `dwDjHP0eIn0D97WHKIgD`,
	"tableReasonForMovementDetailsTitle": `YZxjN5Laer7LUsIlZvaa`,
	"tableReasonForMovementDetailsBody": `sWVucEXT_UWZmbDvuUL0`,
	"showingInfo": `Z0c4WlawKVMsklBPOgFU`,
	"menuItem": `D6DkNeefmUf9T8Y_Vyt0`,
	"formError": `mRM8RxhK8Uo3SBH7yWYO`,
	"panelHeader": `ZlSplrNIK14GVMqoPiEP`,
	"selectableVersionHeader": `dGlV3n5orppgoHhyPRHz`,
	"selectableVersionUserName": `TBIE9YX3hJRTUUmLxnQh`,
	"selectableVersionChange": `QbYRkeu7naEwQqoAOSpe`,
	"selectableVersionDateTime": `ZELy3N5et26z8pvXsFuf`,
	"gridHorizontalRuleShell": `SHEEGJyIZxcBHk8PCyEI`,
	"allBannerStack": `xld3SUHDOkqPrw6rbfLg`,
	"disappearingBannerStack": `VBiSQQFSnyuXKKbY3OFK`,
	"boxListContainer": `gfKXMSQUNi6JnDLuUfg5`,
	"flagIcon": `bvox25T2tIKj8o4wgtKC`,
	"nineboxLeaderCount": `FmopXp24Aag9EGIei7AV`,
	"borderTopLeftRadius": `sBo25kVyC6uvaYbJuMhU`,
	"noBorderTopBottom": `u8AZtbOfu2qLJuyqjdWb`,
	"noBorderTopBottomLeft": `wJj3gCc7vI6uUeg1grAX`,
	"borderTopRightRadius": `SPEDh4nQKVthupKakf_G`,
	"borderBottomLeftRadius": `BO7VaWG1ApZ9SFOhdJ5A`,
	"borderBottomRightRadius": `KB_ltTQhm3t_kDJQ7HKH`,
	"noLeftBorder": `bnkx_AKU34w5SjvBR9YY`,
	"noBorderLeftBottom": `ZNGlpg2Qp52ZDUG62C5V`,
	"axisTooltipModalContainer": `AeyYRdfkDiEJFPCDl1Wo`,
	"axisHeaderTitle": `urFoIjW1OnbyS526OM9H`,
	"scaleTitleContainer": `CoOEGFMnaRVEf1zIlGHh`,
	"scaleTitle": `Y2sGbIZDcPA2FNYavk4c`,
	"cardPanelLoud": `uaSRxOJbllKrHlgpmwGy`,
	"managerName": `qKfa6pyHVDWxV9PYm0Ur`,
	"leaderDetailsPanel": `GjaQkCBxPBmOSZ5hf0tE`,
	"managerRole": `Ye4T8Uv01prn5P0elSD5`,
	"leaderNamePanel": `sjt_IL7X5esmMxZB0Fcu`,
	"sharePermissionModalBodyContainer": `xJWowRbQF9zCr5BTIS2n`,
	"sharePermissionModalWindowContainer": `ZAlguLuafoeZSaYEnqog`,
	"autoCompleteInputBox": `iKwAFmuvZkjzFZTmlwYI`,
	"permissionTypeContainer": `aVheayV7OGLqrBoCkbi4`,
	"permissionTypeLabel": `B6nUQX9qr62aeSnV3Mxy`,
	"viewEditDropdown": `GcMIthcos_kHZPfFOs0Q`,
	"addPermissionsButtonContainer": `SYIoZVoeyabH6YKy9Uyn`,
	"shareChangebles": `yapMSiUsEkhk_Ze21c9b`,
	"leaderNameTitleAndButtonContainer": `LlUlEWr4Wb24kfwOfuUr`,
	"leaderNameAndTitleContainer": `pS9_pOVDhY0I66cqFtDF`,
	"shareAccessPermissionHeader": `S1x60hZkvqvmR7s9FLpq`,
	"leaderNameBubble": `vTFTo1t7XsrgBsCjlXKR`,
	"downViewEditDropdownContainer": `vlBQCr9ZO0wtRdnayG7c`,
	"disableIcons": `GUyMx1EFYHV4b8cd39gL`,
	"tooltipSize": `RqwQmlLX97MMhAUYRDzw`,
	"requiresEditAccessModal": `TzrPOBd8FA1rrhMvoknZ`,
	"leaderPanelRecommendedBox": `SsApMBiZlomShJ02wffu`,
	"bannerMessage": `DVy8lNFQDKk5f0Zkvbdb`,
	"notificationMessages": `aeV96r0etamyoTKViNt1`,
	"tableHeaders": `pXtEApzvap7vogxOmI4N`
};
export default ___CSS_LOADER_EXPORT___;
